import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _11_BIODIVERSITY:Partial<EcosystemServiceModel> ={
  id:'biodiversity',
  pos:11,
  image: "/assets/images/ecoservices/biodiversity.jpg",
  code: ["2.2.2.3"],
  unit:'biodiversity',
  assetType:'species',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'avoidedCost',
      name:"Avoided prices",
      unit: "population",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
        { id: "habitatRichness", name: "Habitat Richness Index", included: true },
        { id: "mitigation", name: "Mitigation Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'contingent',
      name:"Contingent Valuation",
      unit: "population",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
        { id: "habitatRichness", name: "Habitat Richness Index", included: true },
        { id: "mitigation", name: "Mitigation Index", included: true },
      ],
      valueIndices: []
    },
  ]

}
